<template>
  <div id="bar-value" class="vx-row ">
       <div class="vx-col w-full sm:w-1/5 lg:w-1/5 xl:w-1/5">
      <div class="card" >
        <small> {{ $t("totalOil") }}</small>
        <div>
          <p class="h7"><vs-icon icon="invert_colors"></vs-icon> {{data[0]}}  {{ $t("Liter") }}</p>
        </div>
      </div>
    </div>
    <div class="vx-col w-full sm:w-1/5 lg:w-1/5 xl:w-1/5">
      <vx-tooltip text="ยอดรวมน้ำมัน * ราคาน้ำมัน" position="top">
        <div class="card" >
          <small> {{ $t("TotalIsExciseRate") }}</small>
          <div>
            <p class="h7"><vs-icon icon="invert_colors"></vs-icon> {{data[1]}} {{ $t("Baht") }}</p>
          </div>
        </div>
      </vx-tooltip>
    </div>
    <div class="vx-col w-full sm:w-1/5 lg:w-1/5 xl:w-1/5">
      <vx-tooltip text="ยอดรวมน้ำมัน * 6.44" position="top">
        <div class="card" >
          <small> {{ $t("TotalIsExciseExemption") }}</small>
          <div>
            <p class="h7"><vs-icon icon="invert_colors"></vs-icon> {{data[2]}} {{ $t("Baht") }}</p>
          </div>
        </div>
      </vx-tooltip>
    </div>
    <div class="vx-col w-full sm:w-1/5 lg:w-1/5 xl:w-1/5">
      <div class="card" >
        <small> {{ $t("OilPrice") }}</small>
        <div>
          <p class="h7"><vs-icon icon="invert_colors"></vs-icon> {{lastOilPrice.price}} {{ $t("Baht") }}</p>
        </div>
      </div>
    </div>
    <div class="vx-col w-full sm:w-1/5 lg:w-1/5 xl:w-1/5">    
      <div class="card" >
        <small> {{ $t("PercentOfLost") }}</small>
        <div>
          <p class="h7"><vs-icon icon="invert_colors"></vs-icon> {{data[3]}} {{ $t("Baht") }}</p>
        </div>
      </div>
    </div>
  </div> 
</template>
<script>
import { formatNumber } from '@/utils/index';
import { mapState } from "vuex";

export default {
  name: "barValue",
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      formatNumber,
      maxWidth: 250,
      base: 0,
    } 
  },
  mounted() {
    this.$store.dispatch("getLastOilPrice");
  },
  computed:{
    ...mapState({
     lastOilPrice: (state) => state.oilPrice.lastOilPrice,
    })
  }
}
</script>
<style scoped>
.card{
  max-width: 300px;
  min-width: 137px;
  background-color: #F7F7F7;
  border-radius: 5px;
  padding: 2px;
}
</style>